import styled from 'styled-components';

const Title = styled.div`
  width: 100%;
  padding: 10px 0;
  background-color: ${(p) => p.theme.colors.gray100};
  text-align: center;
`;

const CompanyName = styled.div`
  width: 100%;
  min-width: 0;
  overflow: hidden;
  color: ${(p) => p.theme.colors.gray500};
  font-size: ${(p) => p.theme.fontSizes.sm};
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const WorkflowLayout = styled.div`
  display: grid;
  grid-template-columns: minmax(230px, 350px) minmax(0, 1fr);
  gap: 30px;
  margin-bottom: 30px;

  & + & {
    padding-top: 30px;
    border-top: 1px solid ${(p) => p.theme.colors.gray100};
  }

  @media (max-width: 760px) {
    grid-template-columns: 1fr;
  }
`;

const FileDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding-top: 20px;
`;

const DetailRow = styled.div`
  display: grid;
  grid-template-columns: 120px minmax(0, 1fr);
  gap: 12px;

  > :last-child {
    min-width: 0;
    overflow-wrap: anywhere;
  }
`;

const SignaturePanel = styled.div`
  min-width: 0;
`;

const PartySection = styled.section`
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding-top: 20px;

  & + & {
    margin-top: 6px;
  }
`;

const ExternalPartySection = styled(PartySection)`
  margin-top: 20px;
  border-top: 1px solid ${(p) => p.theme.colors.gray100};
`;

const PartyHeading = styled.div`
  display: grid;
  grid-template-columns: 110px minmax(0, 1fr);
  gap: 20px;
  align-items: center;
`;

const ActionLink = styled.button`
  padding: 0;
  border: 0;
  background: transparent;
  color: ${(p) => p.theme.colors.primary500};
  cursor: pointer;
  font: inherit;
  text-decoration: underline;

  &:disabled {
    cursor: default;
    opacity: 0.55;
  }
`;

const ErrorText = styled.div`
  margin-top: 16px;
  color: ${(p) => p.theme.colors.danger};
  font-size: ${(p) => p.theme.fontSizes.sm};
`;

const ModalForm = styled.form`
  position: absolute;
  top: 50%;
  left: 50%;
  box-sizing: border-box;
  width: min(510px, calc(100vw - 32px));
  max-height: calc(100vh - 32px);
  padding: 25px;
  transform: translate(-50%, -50%);
  overflow-y: auto;
  border-radius: 40px 40px 40px 0;
  background-color: #fff;
  outline: none;
`;

const SignerEmail = styled.span`
  overflow-wrap: anywhere;
  white-space: normal;
`;

export {
  SignerEmail,
  ActionLink,
  CompanyName,
  DetailRow,
  ErrorText,
  ExternalPartySection,
  FileDetails,
  ModalForm,
  PartyHeading,
  PartySection,
  SignaturePanel,
  Title,
  WorkflowLayout,
};
